import { ToFlareXMLOptions } from '@common/flare/types/to-flare-xml-options.type';
import { nodeToFlareXML } from '@common/flare/util/prosemirror-flare-xml';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec, ProseMirrorNode } from 'prosemirror-model';

export class MadCapCentralCDataSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapcentralcdata: {
      group: 'inline',
      inline: true,
      attrs: {
        content: { default: undefined, skipExport: true, skipEditorExport: true }
      },
      parseDOM: [{
        tag: 'MadCap\\:centralCData',
        getAttrs(dom: HTMLElement) {
          return {
            content: dom.textContent
          };
        }
      }],
      toDOM(node) {
        return nodeToDOM(node, {
          isVoid: true,
          tagName: 'mc-lwe-cdata',
          tagNameBoxLabel: '<![CDATA]>',
          tagNameBoxTooltip: `<![CDATA[${node.attrs.content ?? ''}]]>`
        });
      },
      toFlareXML(node: ProseMirrorNode, options: ToFlareXMLOptions): string {
        if (options.exportForClipboard) {
          return nodeToFlareXML(node, options, null, {
            xml: `<MadCap:centralCData>${node.attrs.content}</MadCap:centralCData>`
          });
        } else {
          return nodeToFlareXML(node, options, null, {
            xml: `<![CDATA[${node.attrs.content}]]>`
          });
        }
      },
      toDisplayName() { return '#cdata'; },
      isTagNameBox: true,
      specSkip: true
    }
  } satisfies Record<string, NodeSpec>;
}
